import Button from 'antd/lib/button'
import Flex from 'antd/lib/flex'
import Input from 'antd/lib/input'
import { useCallback, useState } from 'react'
import classes from './OverallFeedback.module.less'
import Popover from 'antd/lib/popover'

type OverallFeedbackProps = {
    overallFeedback: string
    setOverallFeedback: (overallFeedback: string) => void
    disabled: boolean
}

export const OverallFeedback = ({
    overallFeedback,
    setOverallFeedback,
    disabled,
}: OverallFeedbackProps) => {
    const [showOverallFeedbackModal, setShowOverallFeedbackModal] = useState(false)
    const [feedback, setFeedback] = useState(overallFeedback)

    const handleSave = useCallback(() => {
        setOverallFeedback(feedback)
        setShowOverallFeedbackModal(false)
    }, [setOverallFeedback, feedback])

    const handleCancel = useCallback(() => {
        setFeedback(overallFeedback)
        setShowOverallFeedbackModal(false)
    }, [overallFeedback, setFeedback, setShowOverallFeedbackModal])

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLTextAreaElement>) => {
            setFeedback(e.target.value)
        },
        [setFeedback]
    )

    const handleOpenChange = useCallback(
        (open: boolean) => {
            if (!open) {
                setFeedback(overallFeedback)
            }
            setShowOverallFeedbackModal(open)
        },
        [overallFeedback, setFeedback]
    )

    const handleOpen = useCallback(() => {
        setShowOverallFeedbackModal(true)
    }, [setShowOverallFeedbackModal])

    return (
        <Popover
            content={
                <div className={classes.overallFeedbackContainer}>
                    <Input.TextArea
                        className={classes.feedbackInput}
                        rows={4}
                        placeholder="Enter your overall feedback"
                        value={feedback}
                        onChange={handleChange}
                    />
                    <Flex justify="end" gap={8} className={classes.footer}>
                        <Button type="default" onClick={handleCancel}>
                            Cancel
                        </Button>
                        <Button type="primary" onClick={handleSave}>
                            Save
                        </Button>
                    </Flex>
                </div>
            }
            title="Overall Feedback"
            placement="bottomRight"
            open={showOverallFeedbackModal}
            arrow={false}
            onOpenChange={handleOpenChange}
            trigger={['click']}
        >
            <Button
                className={classes.addOverallFeedbackButton}
                color="default"
                onClick={handleOpen}
                disabled={disabled}
            >
                {overallFeedback ? 'Edit Overall Feedback' : 'Add Overall Feedback'}
            </Button>
        </Popover>
    )
}
